module.exports = __webpack_public_path__ + "img/1235532650.5ebd1110.jpg";